import type { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Inputs/Select'
import i18n from 'modules/core/lib/i18n'

interface SelectThresholdProps {
  field: Field
}

const SelectThresholdComponent = ({ field }: SelectThresholdProps) => {
  const thresholdOptions = [
    {
      label: i18n.t(
        'time_tracking.settings.overtime.compensation.timeoff.form.fields.threshold.disabled'
      ),
      value: false,
    },
    {
      label: i18n.t(
        'time_tracking.settings.overtime.compensation.timeoff.form.fields.threshold.activated'
      ),
      value: true,
    },
  ]

  return (
    <Select
      field={field}
      label={i18n.t(
        'time_tracking.settings.overtime.compensation.timeoff.form.content_labels.transfer_threshold'
      )}
      options={thresholdOptions}
      showOriginalLabelText
    />
  )
}

export default observer(SelectThresholdComponent)
